import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FeatureFlagDirective } from './directives/feature-flag.directive';
import { FeatureFlagPipe } from './pipes/feature-flag.pipe';

@NgModule({
    declarations: [FeatureFlagDirective, FeatureFlagPipe],
    imports: [CommonModule],
    exports: [FeatureFlagDirective, FeatureFlagPipe],
})
export class FeatureFlagModule {}
